module.exports = __webpack_public_path__ + "static/Maytronics-PSQ_LockUp_DARK-0bb70683cc4349a90b2e8638b1b55b9f.png";